import { HttpClient } from "@angular/common/http";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { environment } from "../../environments/environment";
import { Caddy, CaddyListResponse } from "../model/caddy.model";
import { Observable, of, tap } from "rxjs";
import { isPlatformBrowser } from "@angular/common";

@Injectable({
  providedIn: 'root',
})
export class CaddyService {
  private _httpClient = inject(HttpClient);
  apiUrl = environment.apiUrl + 'caddy';
  private platformId = inject<object>(PLATFORM_ID);
  private isLocalhost = false;
  private cachedData: CaddyListResponse  | undefined = undefined;

  getAll(
    name: string = '',
    code: string = '',
    sortBy: string = '',
    limit: number = 30,
    page: number = 1
  ): Observable<CaddyListResponse> {
    if (this.cachedData) {
      return of(this.cachedData);
    }

    return this._httpClient.get<CaddyListResponse>(this.apiUrl, {
      withCredentials: isPlatformBrowser(this.platformId) && !this.isLocalhost,
      params: {
        limit: limit,
        page: page,
      },
    }).pipe(
      tap((response) => {
        this.cachedData = response;
      })
    );
  }
  create(input: Caddy) {
    return this._httpClient.post<Caddy>(this.apiUrl, input);
  }
  update(input: Caddy, id: string){
    return this._httpClient.put(this.apiUrl+"/"+ id, input, {
      withCredentials: isPlatformBrowser(this.platformId) && !this.isLocalhost,
    });
  }
  delete(id: string){
    return this._httpClient.delete(this.apiUrl+"/"+ id, {
      withCredentials: isPlatformBrowser(this.platformId) && !this.isLocalhost,
    });
  }
  getById(caddyId: string){
    return this._httpClient.get<Caddy>(this.apiUrl+"/"+ caddyId, {
      withCredentials: isPlatformBrowser(this.platformId) && !this.isLocalhost,
    });
  }
}